module.exports = __webpack_public_path__ + "img/waiting-location-marker.1858d710.svg";